import React from 'react';
import { useDispatch } from 'react-redux';
import { format } from 'date-fns';
import { togglePopover } from '../../redux/Slices/popoverSlice';
import './scss/CalendarDayPopover.scss';

// Content for the calendar "+N more" popover (rendered inside the shared
// PopOver chrome). Lists every card due on a given day with its list + time.
const CalendarDayPopover = ({ day, cards = [], onOpenCard, dotColor }) => {
    const dispatch = useDispatch();
    const close = () =>
        dispatch(togglePopover({ contentId: null, position: { top: 0, left: 0 }, targetId: null }));

    const dayDate = day ? new Date(day) : null;

    return (
        <div className="calendar-day-popover">
            <div className="calendar-day-popover__head">
                <div className="calendar-day-popover__date">
                    {dayDate && (
                        <>
                            <span className="calendar-day-popover__weekday">{format(dayDate, 'EEEE')}</span>
                            <span className="calendar-day-popover__daynum">{format(dayDate, 'MMMM d')}</span>
                        </>
                    )}
                </div>
                <span className="calendar-day-popover__count">{cards.length}</span>
            </div>

            <div className="calendar-day-popover__list">
                {cards.map((card) => {
                    const time = card.dueDate?.dueTime;
                    const completed = card.dueDate?.completed || card.completed;
                    return (
                        <button
                            type="button"
                            key={card._id || card.shortId}
                            className={`calendar-day-popover__item${completed ? ' is-done' : ''}`}
                            style={{ '--cal-bar-color': dotColor ? dotColor(card) : 'var(--brand-color)' }}
                            onClick={() => { onOpenCard?.(card); close(); }}
                            title={card.title}
                        >
                            <span className="calendar-day-popover__dot" />
                            <span className="calendar-day-popover__title">{card.title}</span>
                            {time && <span className="calendar-day-popover__time">{time}</span>}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default CalendarDayPopover;
